'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n  display: flex;\n  padding: 18px\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: ", ";\n  background: ", ";\n  border: ", ";\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 23.4px;\n  text-transform: uppercase;\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n          // background: ", ";\n        "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n          ", " {\n            color: ", ";\n          }\n          ", " {\n            color: ", ";\n            &::before,\n            &::after {\n              background: ", ";\n            }\n          }\n          ", " {\n            border: solid 1px ", ";\n            color: ", ";\n          }\n          ", " {\n            color: ", ";\n          }\n        "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  top: 0;\n  left: 0;\n  height: 56px;\n  line-height: inherit;\n  opacity: 1;\n  z-index: 980; /* for less than stepper */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 0;\n  padding-right: 15px\n  padding-top: 1.844rem;\n  padding-bottom: 1.844rem;\n  border-bottom: 1px solid #1D3B49;\n  background-color: ", " !important;\n  color: ", ";\n  border-bottom: ", ";\n  will-change: transform;\n\n  @media (max-width: 768px) { \n    marginleft: 10px;\n    padding-right: 0;\n  }\n\n  \n  ", " .ant-menu-horizontal {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    padding: 0 15px 0 0;\n    border-bottom: none;\n    overflow: hidden;\n  }\n\n  ", ";\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1.5rem\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 24px;\n  cursor: initial;\n\n  @media (max-width: 768px) { \n    margin-left: 10px;\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      display: none;\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  font-size: 12px;\n  font-weight: bold;\n  font-style: italic;\n  color: ", ";\n  padding: 0 11px;\n  text-transform: uppercase;\n  position: relative;\n\n  &::before {\n    ", ";\n    left: 0;\n  }\n\n  &::after {\n    ", ";\n    right: 0;\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      display: flex;\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: none;\n  align-self: center;\n  width: 145px;\n  padding-top: 0;\n  padding-left: 13px;\n  margin-left: 14px;\n  font-size: 10px;\n  line-height: 1.5;\n  text-align: left;\n  color: ", ";\n  cursor: text;\n  white-space: pre-line;\n  ", ";\n  &::before {\n    content: '';\n    border-left: 1px solid ", ";\n    position: absolute;\n    height: 22px;\n    left: 0;\n    bottom: 4px;\n  }\n  &-dark {\n    color: white;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n  height: auto;\n  max-width: 240px;\n  max-height: 30px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: #888;\n  margin-left: 8px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  border-radius:100px;\n  font-size: 7px !important;\n  font-weight: bold;\n  line-height: 9px;\n  letter-spacing: 1px;\n  padding: 0.2rem 0.5rem !important;\n  margin-right: 1.5rem;\n  background: ", ";\n  color: ", " !important;\n  border: ", ";\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 15.6px;\n\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  border-radius:100px;\n  font-size: 7px;\n  font-weight: bold;\n  line-height: 9px;\n  letter-spacing: 1px;\n  padding: 0.5rem 1rem;\n  margin-right: 1.5rem;\n  background: ", ";\n  color: ", " !important;\n  border: ", " !important;\n\n\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 15.6px;\n\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  letter-spacing: normal;\n  text-align: left;\n  color: ", ";\n  font-size: 10px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\ndisplay: flex;\nalign-items: center;\njustify-content: center;\nflex-direction: row;\ngap: 10px;\ntext-align: center;\n\n& > img {\n  //width: 80px;\n  height: auto;\n  margin-bottom: 5px;\n}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  @media all and (min-width: 1200px) {\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    border: 1px solid rgba(149, 149, 149, 0.22);\n    background-clip: padding-box;\n    .fa {\n      margin-right: 8px;\n      font-size: 28px;\n    }\n    .fa-linkedin-square {\n      color: #4176a7;\n    }\n    .fa-facebook-square {\n      color: #465a8c;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _antd = require('antd');

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styled = require('shared/styled');

var _themes = require('../../constants/themes');

var _themes2 = _interopRequireDefault(_themes);

var _mediaTemplates = require('../../styled/mediaTemplates');

var _colorUtils = require('../../utils/colorUtils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeaderLayout = _antd.Layout.Header;

var SocialMediaContainer = _styledComponents2.default.div(_templateObject());

var MobileSection = _styledComponents2.default.div(_templateObject2());

var SocialMediaText = _styledComponents2.default.span(_templateObject3(), _styled.colors.gray.lighter);

var UserRoleWrapper = _styledComponents2.default.span(_templateObject4());

var UserRole = _styledComponents2.default.span(_templateObject5(), function (_ref) {
  var isSp = _ref.isSp,
      accentColor = _ref.accentColor;
  return isSp ? (0, _colorUtils.lightenColor)(accentColor, 0.7) : 'linear-gradient(263.97deg, #3D6980 2.57%, #183543 90.33%)';
}, function (_ref2) {
  var isSp = _ref2.isSp;
  return isSp ? '#1A1A1A' : '#DDDDDDDD';
}, function (_ref3) {
  var isSp = _ref3.isSp,
      theme = _ref3.theme,
      accentColor = _ref3.accentColor;
  return isSp ? "1px solid ".concat(accentColor) : "none";
});

var UserRoleMobile = _styledComponents2.default.span(_templateObject6(), function (_ref4) {
  var isSp = _ref4.isSp,
      accentColor = _ref4.accentColor;
  return isSp ? (0, _colorUtils.lightenColor)(accentColor, 0.7) : 'linear-gradient(263.97deg, #3D6980 2.57%, #183543 90.33%)';
}, function (_ref5) {
  var isSp = _ref5.isSp,
      theme = _ref5.theme;
  return isSp ? '#1A1A1A' : '#DDDDDDDD';
}, function (_ref6) {
  var isSp = _ref6.isSp,
      theme = _ref6.theme,
      accentColor = _ref6.accentColor;
  return isSp ? "1px solid ".concat(accentColor) : "none";
});

var UserTitle = _styledComponents2.default.span(_templateObject7());

var styleLogoLink = "\n  display: flex;\n  align-self: center;\n";
var LogoInnerLink = (0, _styledComponents2.default)(_reactRouterDom.Link)(_templateObject8(), styleLogoLink);

var LogoLink = _styledComponents2.default.a(_templateObject9(), styleLogoLink);

var LogoImg = _styledComponents2.default.img(_templateObject10());

var Slogan = _styledComponents2.default.span(_templateObject11(), _styled.colors.gray.lighter, _mediaTemplates.media.desktopHigh(_templateObject12()), _styled.colors.gray.lighter);

var LogoShort = _styledComponents2.default.div(_templateObject13());

var Circle = function Circle(color) {
  return " \n  content: '';\n  width: 4px;\n  height: 4px;\n  background: ".concat(color, ";\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 2px;");
};

var MainSlogan = _styledComponents2.default.span(_templateObject14(), function (props) {
  return props.isShown ? 'inline-block' : 'none';
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return Circle(props.theme.platformPrimary);
}, function (props) {
  return Circle(props.theme.platformPrimary);
}, _mediaTemplates.media.desktopHigh(_templateObject15()), _mediaTemplates.media.allMobiles(_templateObject16()));

var Logo = _styledComponents2.default.span(_templateObject17());

var TitleSection = _styledComponents2.default.div(_templateObject18());

var Title = _styledComponents2.default.div(_templateObject19());

var UserName = _styledComponents2.default.span(_templateObject20(), _styled.colors.black);

var Header = (0, _styledComponents2.default)(HeaderLayout)(_templateObject21(), function (_ref7) {
  var isSp = _ref7.isSp,
      theme = _ref7.theme,
      accentColor = _ref7.accentColor;
  return isSp ? (0, _colorUtils.lightenColor)(accentColor, 0.7) : '#0E181D';
}, function (_ref8) {
  var isSp = _ref8.isSp,
      theme = _ref8.theme;
  return isSp ? '#1A1A1A' : '#D3D4D9';
}, function (_ref9) {
  var isSp = _ref9.isSp;
  return isSp ? "1px solid #B3B3B3" : "none";
}, function (props) {
  return props.needToFixedHeaders && _styledComponents.css(_templateObject22());
}, function (props) {
  return props.theme.name === _themes2.default.BLACK ? _styledComponents.css(_templateObject23(), Slogan, _styled.colors.white, MainSlogan, _styled.colors.white, _styled.colors.white, UserRole, props.theme.platformPrimary, props.theme.platformPrimary, UserName, _styled.colors.white) : _styledComponents.css(_templateObject24(), _styled.colors.white);
});

var UserCircle = _styledComponents2.default.div(_templateObject25(), function (_ref10) {
  var isSp = _ref10.isSp,
      theme = _ref10.theme;
  return isSp ? '#FFFFFF' : '#B5C3CA';
}, function (_ref11) {
  var isSp = _ref11.isSp,
      theme = _ref11.theme,
      accentColor = _ref11.accentColor;
  return isSp ? accentColor : '#1D3B49';
}, function (_ref12) {
  var isSp = _ref12.isSp,
      theme = _ref12.theme;
  return isSp ? "1px solid #B5C3CA" : "none";
});

exports.default = {
  UserCircle: UserCircle,
  Header: Header,
  TitleSection: TitleSection,
  Title: Title,
  Logo: Logo,
  LogoLink: LogoLink,
  LogoInnerLink: LogoInnerLink,
  LogoImg: LogoImg,
  MobileSection: MobileSection,
  Slogan: Slogan,
  MainSlogan: MainSlogan,
  LogoShort: LogoShort,
  UserRoleWrapper: UserRoleWrapper,
  UserRole: UserRole,
  UserRoleMobile: UserRoleMobile,
  SocialMediaContainer: SocialMediaContainer,
  SocialMediaText: SocialMediaText,
  UserTitle: UserTitle,
  UserName: UserName
};